import { render, staticRenderFns } from "./CollageGoods.vue?vue&type=template&id=6bcd427c&scoped=true"
import script from "./CollageGoods.vue?vue&type=script&lang=js"
export * from "./CollageGoods.vue?vue&type=script&lang=js"
import style0 from "./CollageGoods.vue?vue&type=style&index=0&id=6bcd427c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd427c",
  null
  
)

export default component.exports